<p-dialog header="{{ 'contract_attachemnts' | translate }}" [(visible)]="showDialog">

    <div class="container">
        <button (click)="file_upload.click()" pButton icon="pi pi-plus" type="button"
            label="{{'contract_attachemnts_add' | translate}}" class="ui-button-raised ui-button-info"
            [disabled]="uploadInProgress"></button>
        <input type="file" hidden #file_upload (change)="onAttachmentChange($event)"
            accept="image/*, application/pdf">
        <app-loader *ngIf="showLoader || uploadInProgress"></app-loader>
        <div *ngIf="uploadInProgress">
            <h3 class="no-data-header">{{ 'upload_in_progress' | translate }}</h3>
        </div>
        <div *ngIf="!showLoader">
            <div class="attachments">
                <div *ngIf="!contractAttachments.length">
                    <h3 class="no-data-header">{{ 'no_data' | translate }}</h3>
                </div>
                <div *ngIf="contractAttachments.length">
                    <div *ngFor="let attach of contractAttachments; let i = index;" class="line-wrapper">
                        <div class="section-1">
                            <span>{{ i + 1 }}</span>
                        </div>
                        <div class="section-2">
                            <p class="file-name" (click)="onDownloadAttachment(attach.id)">{{ attach.display_name }} </p>
                        </div>
                        <div class="section-3">
                            <span *ngIf="'new' == attach.status"
                                class="status status-new">{{ 'contract_attachemnts_status_new' | translate }}</span>
                            <span *ngIf="'accepted' == attach.status"
                                class="status status-accepted">{{ 'contract_attachemnts_status_accepted' | translate }}</span>
                            <span *ngIf="'rejected' == attach.status"
                                class="status status-rejected">{{ 'contract_attachemnts_status_rejected' | translate }}</span>
                        </div>
                        <div class="section-4">
                            <p-menu #menu [popup]="true" [model]="functionsMenu" appendTo="body"></p-menu>
                            <button type="button" pButton icon="pi pi-cog"
                                (click)="onPopulateFunctionsMenu($event, attach.status, attach.id)"
                                [disabled]="uploadInProgress"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p-footer>
        <button (click)="onCloseModal()" pButton type="button" [disabled]="uploadInProgress"
            label="{{'close_btn' | translate}}" class="ui-button-raised ui-button-info"></button>
    </p-footer>
</p-dialog>

<p-confirmDialog #confirmDialog header="{{ 'confirmation' | translate }}">
    <p-footer>
        <button style="min-width: 60px;" type="button" class="ui-button-success" pButton icon="pi pi-check"
            (click)="confirmDialog.accept()"></button>
        <button style="min-width: 60px;" type="button" class="ui-button-warning" pButton icon="pi pi-times"
            (click)="confirmDialog.reject()"></button>
    </p-footer>
</p-confirmDialog>